import { Construction } from "lucide-react";

export default function MemberPlaceholder({ title, overline, body }) {
  return (
    <section className="container-page py-16" data-testid={`member-placeholder-${overline?.toLowerCase()}`}>
      <div className="overline">{overline}</div>
      <h1 className="display-heading text-4xl sm:text-5xl mt-3">{title}</h1>
      <span className="accent-rule mt-6 block" />
      <div className="mt-12 max-w-2xl bg-white border border-[hsl(var(--border))] p-10">
        <Construction className="h-8 w-8 text-[hsl(var(--accent))]" />
        <h2 className="display-heading text-2xl mt-6">Em preparação.</h2>
        <p className="mt-4 text-[hsl(var(--muted-foreground))] leading-relaxed">{body}</p>
      </div>
    </section>
  );
}
